// import Calendar from "@/utils/calendar";
const statusList = ["初检","复检","","质检","成品","异常","次品"]

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    fixed:'left',
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "所属仓库",
    dataIndex: "warehouse",
    key: "warehouse",
    width: 150,
    fixed:'left',
  },
  {
    title: "库区名称",
    dataIndex: "regionName",
    key: "regionName",
  },
  {
    title: "库区负责人",
    dataIndex: "regionContact",
    key: "regionContact",
  },
  {
    title: "负责人电话",
    dataIndex: "contactPhone",
    key: "contactPhone",
  },
  {
      title: '库区地址',
      dataIndex: 'regionAddress',
      key: 'regionAddress'
  },
  {
    title: "关联的类目",
    dataIndex: "bindStatus",
    key: "bindStatus",
    customRender: (text, record, index) => {
      // return Calendar.d1(statusList[text]);
      return statusList[text]
    },
  },
  // {
  //     title: '创建时间',
  //     dataIndex: 'lmt',
  //     key: 'lmt',
  //     customRender: (text, record, index) => {
  //         return Calendar.d1(text)
  //     },
  // },
  {
    title: "创建时间",
    dataIndex: "lmt",
    key: "lmt",
  },
  {
    title: "操作",
    dataIndex: "id",
    key: "idAction",
    width: 150,
    fixed:'right',
    scopedSlots: {
      customRender: "action",
    },
  },
];
